import { Component, Input } from '@angular/core';
import { Expert } from '../expert-card/expert-card';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '../../../../core/pipes/translate.pipe';

@Component({
  selector: 'app-expert-profile-deals',
  imports: [CommonModule, TranslatePipe],
  templateUrl: './expert-profile-deals.html',
  styleUrl: './expert-profile-deals.scss',
})
export class ExpertProfileDealsComponent {
  @Input({ required: true }) expert!: Expert;
}
